import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouteMatch, Link } from "react-router-dom";

import axios from "../../helpers/axios";
import {
  GeneralTable,
  Layout,
  Notification,
  ScreenHeading,
} from "../../webtracking/components";

import { EtaRowActions, EtaSwitcher } from "../components";

const useSosEtaList = () => {
  const [search, setSearch] = useState("");
  const [etas, setEtas] = useState([]);
  const [message, setMessage] = useState("");
  const [isLoading, setLoading] = useState(true);

  const loadEtas = () => {
    setLoading(true);

    axios
      .get("/api/delivery_time/?limit=1000")
      .then(({ data }) => {
        // @TODO implement paginator
        setEtas(data.results);
      })
      .catch((error) => {
        setMessage("No se pudo completar la petición.");
        console.error(error);
      })
      .then(() => {
        setLoading(false);
      });
  };

  const handleDelete = (eta) => {
    const confirmation = window.confirm(
      "¿Esta seguro que desea eliminar este tipo de envío?"
    );

    if (!confirmation) {
      return;
    }

    axios
      .delete(`/api/delivery_time/${eta.id}/`)
      .then(() => {
        setEtas(etas.filter((row) => row.id !== eta.id));
      })
      .catch(() => {
        setMessage("Something went wrong");
      })
      .then(() => {});
  };

  useEffect(() => {
    loadEtas();
  }, []);

  return {
    etas: etas.filter(
      (eta) =>
        eta.sos.indexOf(search) !== -1 ||
        eta.shipping_type.indexOf(search) !== -1
    ),
    message,
    isLoading,
    handleDelete,
    search,
    setSearch,
  };
};

const SosEtaList = () => {
  const {
    etas,
    message,
    isLoading,
    handleDelete,
    search,
    setSearch,
  } = useSosEtaList();
  const { path } = useRouteMatch();

  const cols = [
    {
      label: "Fuente de suministro",
      render: (row) => <span>{row.sos}</span>,
    },
    {
      label: "Tipo de envío",
      render: (row) => <span>{row.shipping_type}</span>,
    },
    {
      label: "Descripción",
      render: (row) => <span>{row.description}</span>,
    },
    {
      label: "ETA (días naturales)",
      render: (row) => <span>{row.estimated_days}</span>,
    },
    {
      label: "Acciones",
      render: (row) => (
        <EtaRowActions eta={row} onDelete={() => handleDelete(row)} />
      ),
    },
  ];

  return (
    <Layout>
      <ScreenHeading title="ETA fuentes de suministro">
        <EtaSwitcher checked="/eta/sos" />
      </ScreenHeading>

      <div className="container has-background-light p-6 mt-5">
        <Notification message={message} />

        <div className="card mb-5">
          <div className="card-content">
            <div className="level">
              <div className="level-left">
                <div className="control has-icons-left">
                  <input
                    type="text"
                    className="input"
                    placeholder="Buscar"
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                  />
                  <div className="icon is-left">
                    <FontAwesomeIcon icon={["fas", "search"]} />
                  </div>
                </div>
              </div>
              <div className="level-right">
                <Link to={`${path}/create`} className="button is-primary">
                  Crear nuevo
                </Link>
              </div>
            </div>
          </div>
        </div>

        <GeneralTable
          rowKey="id"
          isLoading={isLoading}
          rows={etas}
          cols={cols}
        />
      </div>
    </Layout>
  );
};

export default SosEtaList;
